import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import "../style/Theme.css";
import PhaseLayout from "../../../phase1_6Layout/PhaseLayout";
import { AuthContext } from "../../../auth/AuthProvider";
import LoadingSpinner from "../../../loadingSpinner/LoadingSpinner";

export default function QuestionsP1() {
  const {
    apiUrl,
    user,
    googleUser,
    setPayed,
    setPayedStressFatigue,
    refreshTrigger,
    setRefreshTrigger,
    bgColor,
    themePayed,
    setThemePayed,
    setRedirection,
    setError,
  } = useContext(AuthContext);

  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState([]);
  const [theme, setTheme] = useState({});
  const [phase2, setPhase2] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [addedAnswer, setAddedAnswer] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  // const [themePayed, setThemePayed] = useState({});
  const [themes, setThemes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [themeProgress, setThemeProgress] = useState(0);

  const lastValidVidUrl = useRef(null);
  const navigate = useNavigate();
  const { id, phaseTitle, hashed } = useParams();
  const location = useLocation();

  // ------------------ FETCH INITIAL DATA ------------------
  useEffect(() => {
    // localStorage.setItem("location", location.pathname);

    const fetchInitialData = async () => {
      try {
        const [themeRes, questionsRes, answersRes, phaseRes] =
          await Promise.all([
            axios.get(`${apiUrl}/theme/${id}`),
            axios.get(`${apiUrl}/question/byPhaseAndTheme/${phaseTitle}/${id}`),
            axios.get(`${apiUrl}/answer`),
            axios.get(`${apiUrl}/phase/byTheme/${id}`),
          ]);

        setTheme(themeRes.data);
        setQuestions(questionsRes.data.sort((a, b) => a.id - b.id));
        setAnswers(answersRes.data.sort((a, b) => a.questionId - b.questionId));
        setPhase2(phaseRes.data);
      } catch (error) {
        console.error("Failed to fetch initial data:", error);
      }
    };

    fetchInitialData();
  }, [apiUrl, id, phaseTitle]);

  // ------------------ FETCH PAYMENT STATUS ------------------
  useEffect(() => {
    const fetchPaymentStatus = async () => {
      if (!user && !googleUser) return;

      const identifier = user
        ? { username: user.username }
        : { googleEmail: googleUser.email };

      const question = questions.find((q) => q.text === "Question 1_3");

      if (question?.hashed === hashed) {
        try {
          const res = await axios.get(
            user
              ? `${apiUrl}/success/username/${user.username}/${id}`
              : `${apiUrl}/success/googleEmail/${googleUser.email}/${id}`,
          );

          setThemePayed((prevState) => ({
            ...prevState,
            [id]: res.data,
          }));
          // if (id === "love-and-disappointment") setPayed(res.data);
          // else setPayedStressFatigue(res.data);
        } catch (error) {
          console.error("Failed to fetch payment status:", error);
        }
      }
    };

    if (user) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        username: user.username,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        // setUserProgress(response.data);
      });
    }

    if (googleUser) {
      const progress = {
        themeSlug: id,
        phaseName: phaseTitle,
        uuid: hashed,
        googleEmail: googleUser.email,
      };

      axios.post(`${apiUrl}/user-progress/add`, progress).then((response) => {
        // setUserProgress(response.data);
      });
    }

    async function loadData() {
      try {
        if (!user && !googleUser) return;

        const identifier = user ? user.username : googleUser.email;

        const userEndpoint = user ? "byUserAndTheme" : "byGoogleUserAndTheme";
        const fullUserEndpoint = user ? "byUserInfo" : "byGoogleUserInfo";

        const latestQuestion = await axios.get(
          `${apiUrl}/user-question/${userEndpoint}/${identifier}/${id}`,
        );

        const sortedLatestQuestion = latestQuestion.data.sort(
          (a, b) => b.questionId - a.questionId,
        );

        const sortedLatestQuestion1 = latestQuestion.data.sort(
          (a, b) => b.id - a.id,
        );
        const lastQuestion = await axios.get(
          `${apiUrl}/user-question/${fullUserEndpoint}/${identifier}/${id}/Phase 5`,
        );

        const completed = lastQuestion.data.some(
          (q) =>
            q.questionIndex === 5 &&
            q.phaseName === "Phase 5" &&
            q.questionNumber === "Question 5_5",
        );

        if (completed) {
          setThemeProgress(5);
          return;
        }

        setThemeProgress(sortedLatestQuestion[0]?.questionIndex);

        // setThemeProgress(latestQuestion.data[0]?.questionIndex);
      } catch (error) {}
    }

    fetchPaymentStatus();
    loadData();
  }, [user, googleUser, id, apiUrl]);

  // ------------------ ANSWER SUBMISSION ------------------
  const submitAnswer = async (answerData) => {
    try {
      const response = await axios.post(
        `${apiUrl}/user-question/add`,
        answerData,
      );
      setAddedAnswer(response.data);
      lastValidVidUrl.current = selectedAnswer.vidUrl;
      setRefreshTrigger(Date.now());
      navigate(
        `/session/${id}/${phaseTitle}/${hashed}/${encodeURIComponent(selectedAnswer.label1)}`,
      );
    } catch (error) {
      console.error("Failed to submit answer:", error);
    }
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();
    if (!selectedAnswer) return;

    const answerData = {
      questionId: selectedAnswer.questionId,
      answerLabel: selectedAnswer.label1,
      phaseId: selectedAnswer.phaseId,
      reflectionVideoUrl: selectedAnswer.vidUrl,
      themeSlug: id,
      ...(user ? { userUsername: user.username } : {}),
      ...(googleUser ? { googleEmail: googleUser.email } : {}),
    };

    const answerProgressData = {
      questionId: selectedAnswer.questionId,
      answerLabel: selectedAnswer.label1,
      phaseId: selectedAnswer.phaseId,
      reflectionVideoUrl: selectedAnswer.vidUrl,
      themeSlug: id,
      phaseTitle: phaseTitle,
      hashed: hashed,
      ...(user ? { userUsername: user.username } : {}),
      ...(googleUser ? { googleEmail: googleUser.email } : {}),
    };

    // Save for guest users
    if (!user && !googleUser) {
      const localKey =
        selectedAnswer.questionId === questions[0]?.id
          ? "first_answer"
          : "second_answer";

      const localKey1 =
        selectedAnswer.questionId === questions[0]?.id
          ? "first_answer_progress"
          : "second_answer_progress";
      localStorage.setItem(localKey, JSON.stringify(answerData));
      localStorage.setItem(localKey1, JSON.stringify(answerProgressData));

      const storedAnswer = JSON.parse(localStorage.getItem(localKey));
      navigate(
        `/session/${storedAnswer.themeSlug}/${phaseTitle}/${hashed}/${encodeURIComponent(storedAnswer.answerLabel)}`,
      );
      return;
    }

    // Submit for logged in users
    submitAnswer(answerData);
  };

  // ------------------ HELPER VARIABLES ------------------
  const currentQuestion = questions.find((q) => q.hashed === hashed);
  const answersForCurrentQuestion = answers.filter((a) => a.hashed === hashed);

  if (!currentQuestion)
    return (
      <LoadingSpinner
        customBg={"rgba(20, 13, 8, 0.92)"}
        customColor={"white"}
      />
    );
  // return <h1 style={{ color: "white" }}>Loading question...</h1>;

  // ------------------ RENDER ------------------
  return (
    <>
      <div
        className="question-container"
        style={{ backgroundColor: bgColor || "" }}
      >
        <div className="back-btn-div">
          <div>
            <Link to={`/session/${id}`} className="back-btn" id="back-btn">
              <span className="back">❮</span>
              {/* <span className="backSession">Back to session</span> */}
            </Link>
          </div>
          <section>
            <div>
              <p>{theme.title}</p>
            </div>
            <div>
              <h6>{phaseTitle}</h6>
              <h6>•</h6>
              <h6>Question {currentQuestion.questionNumber}/5</h6>
            </div>

            {/* <hr /> */}
          </section>
          <div className="hamburger-div">
            {!isOpen && (
              <button
                id="hamburger"
                className="hamburger"
                type="button"
                onClick={() => setIsOpen(true)}
                aria-label="Open menu"
                id="hamburger-question"
                // style={{
                //   color: "black",
                // }}
              >
                ☰
              </button>
            )}
            {isOpen && (
              <div
                className="sidebar-backdrop"
                onClick={() => setIsOpen(false)}
              />
            )}
          </div>
        </div>

        {/* <section>
          <h6>{phaseTitle}</h6>
          <h6>{currentQuestion.text}</h6>
          <hr />
        </section> */}

        {/* <div style={{ color: "gray" }} className="phaseSectionParagraph psp">
          <div
            className="progressLineParent"
            id="progressLineParent"
            style={{
              // width: "14px",
              width: `${Math.floor(((themeProgress || 0) / 5) * 100)}%`,
            }}
          >
            <div className="progressLineChild" id="progressLineChild"></div>
          </div>
        </div> */}

        <section>
          <div key={hashed} className="feedback-container1">
            <h3>
              {phaseTitle} {phase2[0]?.name}
            </h3>
            <h1>{currentQuestion.name}</h1>
            <form onSubmit={handleSubmit1}>
              {answersForCurrentQuestion.map((a) => (
                <div key={a.id}>
                  <label className="labelAnswer">
                    <input
                      type="submit"
                      name={`q-${hashed}`}
                      value={a.label}
                      checked={selectedAnswer?.id === a.id}
                      onClick={() =>
                        setSelectedAnswer(
                          selectedAnswer?.id === a.id
                            ? null
                            : {
                                id: a.id,
                                vidUrl: a.reflectionVideoUrl,
                                label1: a.label,
                                questionId: a.questionId,
                                phaseId: a.phaseId,
                                phaseName: phaseTitle,
                                themeSlug: id,
                                uuid: hashed,
                              },
                        )
                      }
                    />
                    <span>{a.label}</span>
                  </label>
                  <br />
                </div>
              ))}
              {/* <button
                className="btnQuestion"
                type="submit"
                disabled={!selectedAnswer}
              >
                Submit
              </button> */}
            </form>
          </div>
        </section>
      </div>

      <div
        id="sidebarTheme"
        className={`sidebar ${isOpen ? "open" : "closed"}`}
      >
        <button
          id="closeBtn"
          className="close-btn"
          type="button"
          onClick={() => setIsOpen(false)}
          aria-label="Close menu"
          style={{
            backgroundColor: "transparent",
            color: "rgba(242, 237, 229, 0.78)",
          }}
        >
          X
        </button>

        <div className="plParent">
          <PhaseLayout />
        </div>
      </div>
    </>
  );
}
